export default "__VITE_ASSET__c74Ib$Sa__"